module.exports = "data:image/gif;base64,R0lGODlhEAAWAKUTAMzMzODg4NfX18nJyaSkpMjIyNHR0fz8/O7u7k9PT01NTfHx8d7e3vX19fb29rm5ud3d3d/f3/Dw8P///9vb2/j4+PPz8/39/dra2srKyu/v79LS0tPT09nZ2dTU1FBQUNbW1sfHx/v7++Li4vT09Pf39/n5+U5OTsXFxdzc3M3NzcvLy/r6+uzs7M/Pz1FRUdXV1cbGxuPj4+Xl5fLy8uHh4f7+/u3t7djY2Obm5v///////////////////////yH5BAEKAD8ALAAAAAAQABYAAAabwItwSCx2FsikUilcOpUNiXRKrYo02Kx2K0J4p14E2NtFLA6Xw8KMVpNvCNZLkTjQDgnFi4W4iVotGnh0F3l1GoAsEIsyJnkKdCYyixAOGJcYARWGFQGYGA4doqIRFR8VEaOiDgKtrgwkDK6uDiC2tyAduLcOHr6/wMEOHMTFxscOG8rLzM0OBtDR0tPP09bR1dfW2drS3N3QDkEAOw=="


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/trigger.gif
 ** module id = 240
 ** module chunks = 0 1
 **/